<script setup>
const { routePath } = useRoutePath()
const { t } = useI18n()

// http://localhost:4000/p/6-teamup-tester/start/?next=/p/6-teamup-tester/
const loginUrl = computed(() => `/start/?next=${routePath.value}`)
</script>

<template>
  <AppLoginLogoutButtonTemplate
    :url="loginUrl"
    icon="i-far-right-from-bracket"
    :label="t('Log in / Register')"
  />
</template>

<i18n>
{
  "en-us": {
    "Log in / Register": "Log in / Register",
    "Log in": "Log in",
    "Register": "Register"
  }
}
</i18n>

<i18n locale="de" lang="json">
{
  "Log in / Register": "Anmelden / Registrieren",
  "Log in": "Anmelden",
  "Register": "Registrieren"
}
</i18n>

<i18n locale="fr" lang="json">
{
  "Log in / Register": "Se connecter / S'inscrire",
  "Log in": "Se connecter",
  "Register": "S'inscrire"
}
</i18n>

<i18n locale="es" lang="json">
{
  "Log in / Register": "Iniciar sesión / Registrarse",
  "Log in": "Iniciar sesión",
  "Register": "Registrarse"
}
</i18n>
